const LOOPBACK_HOSTS = new Set(['127.0.0.1', 'localhost', '::1']);

/**
 * Resolve the backend URL used by the browser.
 *
 * Local development intentionally uses a loopback backend. If that value is
 * embedded in a bundle served from a remote host, use the frontend hostname
 * instead of making the user's browser call its own 127.0.0.1.
 */
export const getBackendHost = (): string => {
  const configuredHost = (process.env.REACT_APP_BACKEND_HOST || '').trim();
  const pageHost = typeof window !== 'undefined' ? window.location.hostname : '';
  const pageOrigin = typeof window !== 'undefined' ? window.location.origin : undefined;

  if (!configuredHost) return pageOrigin || '';

  try {
    const backendUrl = new URL(configuredHost, pageOrigin || undefined);
    if (pageHost && !LOOPBACK_HOSTS.has(pageHost) && LOOPBACK_HOSTS.has(backendUrl.hostname)) {
      backendUrl.hostname = pageHost;
    }
    return backendUrl.toString().replace(/\/$/, '');
  } catch {
    return configuredHost.replace(/\/$/, '');
  }
};
